// src/components/auth/utils.js
import { CONFIG } from './constants';

export const logDebug = (message, data = null) => {
  if (CONFIG.DEBUG) {
    const timestamp = new Date().toISOString();
    const logStyle = 'background: #4285F4; color: white; padding: 2px 4px; border-radius: 2px;';
    
    if (data) {
      console.log(`%c[Google Auth ${timestamp}]`, logStyle, message, data);
    } else {
      console.log(`%c[Google Auth ${timestamp}]`, logStyle, message);
    }
  }
};

export const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const loadScript = (src, onLoad, onError) => {
  if (document.querySelector(`script[src="${src}"]`)) {
    onLoad && onLoad();
    return;
  }
  
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.defer = true;
  script.onload = onLoad;
  script.onerror = onError;
  
  document.body.appendChild(script);
};